import Vue from 'vue';
import axios from 'axios';
import store from '../store';

export interface ValidationErrors {
    field: string;
    message: string
}

export default class ServiceBase extends Vue {
    cook = store.getters.userToken;
    baseURL = '/api/';
    streamFileBase = '/api/Document/CreatePdf';

    config = {
        baseURL: 'api/Pass/Process',
        headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + this.cook
        }
    }

    docConfig = {
        headers: {
            'Authorization': 'Bearer ' + store.getters.userToken
        },
        responseType: 'blob'
    }

    public uploadFiles(formData: FormData): Promise<any> {
        return axios.post('api/Document/Upload', formData, {
            headers: {
                'Authorization': 'Bearer ' + this.cook
            }
        })
            .then((response) => {
                let result = response.data;

                if (!result.isSuccess) {
                    store.dispatch("isLoading", false);

                    var emptyMessages: any[] = [];

                    let msgs = {
                        class: 'error',
                        messages: emptyMessages
                    }

                    if (result.status.statusMessage != '')
                        msgs.messages.push(result.status.statusMessage);

                    if (result.status.statusCode == 422) {
                        result.validationErrors.forEach(function (value: ValidationErrors) {
                            msgs.messages.push(value.field + ": " + value.message);
                        });
                    }

                    store.dispatch('addApplicationMessages', msgs);


                }
                else
                    return result.responseData;
            })
            .catch(error => {
                //store.dispatch('addApplicationMessages', error);
            })
    }

    public streamFiles(url: string, data: any, options?: any): Promise<any> {
        if (!options)
            options = this.docConfig;

        let obj = {
            URL: this.baseURL + url,
            Method: 'POST',
            data: data
        }
        
        options.baseURL = this.streamFileBase; 
        store.dispatch("isLoading", true);
        store.dispatch("clearMessages");

        return axios.post('', obj, options)
            .then((response) => {
                if (response.headers["content-type"].indexOf("json") > -1) {
                    let reader = new FileReader();
                    return new Promise((resolve, reject) => {
                        reader.readAsText(response.data);
                        reader.onload = () => {
                            resolve(this.getStringFromBlob(reader));
                        }
                    });
                }
                else
                    return response.data;
            })
            .catch(error => {
                if (error.response.status == 404)
                    error.isSuccess = false;
                return error;
            })
    }

    private getStringFromBlob(reader: FileReader) {
        let base64data = reader.result;
        if (base64data && typeof base64data === 'string') {
            let data = JSON.parse(base64data);
            return Promise.resolve(data);
        }
    }

    public post(url: string, data: any, options?: any): Promise<any> {

        return this.send('POST', url, data, options);
    }

    public get(url: string): Promise<any> {
        return this.send('GET', url, {});
    }

    public put(url: string, data: any): Promise<any> {
        return this.send('PUT', url, data);
    }

    private send(method: string, url: string, data: any, options?: any): Promise<any> {
        if (!options)
            options = this.config;

        let obj = {
            URL: this.baseURL + url,
            Method: method,
            data: data
        }

        store.dispatch("isLoading", true);
        store.dispatch("clearMessages");

        return axios.post('', obj, options)
            .then((response) => {
                let result = response.data;

                if (!result.isSuccess) {
                    store.dispatch("isLoading", false);

                    var emptyMessages: any[] = [];

                    let msgs = {
                        class: 'error',
                        messages: emptyMessages
                    }

                    if (result.status.statusMessage != '')
                        msgs.messages.push(result.status.statusMessage);

                    if (result.status.statusCode == 422) {
                        result.validationErrors.forEach(function (value: ValidationErrors) {
                            msgs.messages.push(value.field + ": " + value.message);
                        });
                    }

                    store.dispatch('addApplicationMessages', msgs);

                    throw result;
                }
                else
                    return result.responseData;
            })

    }

    public all(collection: any[]) {
        return new Promise((resolve, reject) => {
            const requests = collection.map((req: any) => {
                return this.post(req.url, req.data);
            })

            axios.all(requests);
        })
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/services/ServiceBase.ts